import { safeLocalStorage } from 'wsm-tagging-utils';
import findVehicleByProperty from './findVehicleByProperty';
import getFormTitle from './getFormTitle';
import widgetIsPresent from './widgetIsPresent';

const getFieldValue = (form, fieldName) =>
	form?.querySelector?.(`input[name="${fieldName}"]`)?.value || '';

const getFormEventData = ({
	form,
	vehicles = [],
	dataLayer: { page: { pageInfo: { pageWidgets = [] } = {} } = {} } = {}
}) => {
	const formTrackingName = form?.dataset?.formTrackingName;
	const uuid =
		getFieldValue(form, 'itemId') ||
		getFieldValue(form, 'vehicleId') ||
		getFieldValue(form, 'dl.uuid');

	const initiatingClickText = safeLocalStorage.getItem(
		'ddc_data_layer-initiatingClickText'
	);

	const eventData = {
		currentTime: new Date().getTime(),
		customFormId: getFieldValue(form, 'custom.form.id'),
		formTitle: getFormTitle(form),
		...(formTrackingName && {
			formTrackingName
		}),
		isSRP: widgetIsPresent(/ws-inv-listing/, pageWidgets),
		trackingId: form?.dataset?.formTrackingId,
		trackingTags: getFieldValue(form, 'trackingTags'),
		vehicle: uuid ? findVehicleByProperty('uuid', uuid, vehicles) : {},
		isLead: getFieldValue(form, '_action').length > 0,
		isModal: form?.dataset?.modal === 'true',
		...(initiatingClickText && { initiatingClickText })
	};

	return eventData;
};

export default getFormEventData;
